import React from "react";
import { IconColor } from "../interface/ColorInterface";

export const PricingIconSvg: React.FC<IconColor> = ({
  color,
  width,
  height,
  transform,
}) => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    transform={transform}
  >
    <path
      d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM12 19C9.24 19 7 16.76 7 14H9C9 15.66 10.34 17 12 17C13.66 17 15 15.66 15 14C15 12.34 13.66 11 12 11H11V9H13C14.1 9 15 8.1 15 7C15 5.9 14.1 5 13 5H11C9.9 5 9 5.9 9 7H7C7 4.79 8.79 3 11 3H13C15.21 3 17 4.79 17 7C17 8.85 15.66 10.43 13.9 10.9C15.73 11.37 17 13.02 17 15C17 17.76 14.76 20 12 20V19Z"
      fill={color || "white"}
    />
  </svg>
);
